import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { RequestFormType } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class CommonPopupSourceMetricRequestFormComponent extends PopupInnerModalComponent<PopupData.Common.SourceMetricRequestForm> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('navigation') declare navigationService: Service.Navigation;

	get type() {
		return this.popupData.type;
	}

	get title() {
		return this.type === RequestFormType.SOURCE
			? 'Request a new integration'
			: 'Request a new metric';
	}

	get icon() {
		return this.type === RequestFormType.SOURCE ? 'Data' : 'Metrics';
	}

	get iframeUrl() {
		const email = this.currentUserService.model!.email;
		const category =
			this.type === RequestFormType.SOURCE ? 'integrationRequest' : 'metricRequest';
		const theme = this.args.model.theme || this.navigationService.theme.id;
		const params = new URLSearchParams({ email, category, theme });
		return `https://databox.com/embed/v1/roadmap-request?${params}`;
	}

	<template>
		<div class="title">
			<CommonUiIconComponent @name={{this.icon}} @size="lg" />
			<span>{{this.title}}</span>
		</div>

		<div class="content">
			<div class="form-container">
				<iframe
					title="Request data source or metric"
					src={{this.iframeUrl}}
					width="100%"
					height="100%"
					frameborder="0"
				></iframe>
			</div>
		</div>
	</template>
}
